import React, { FC, useState, useContext } from "react";
import Select from "antd/lib/select";
import styled from "styled-components";
import { ReactComponent as AddContactIcon } from "../../icons/add_contact.svg";
import ContactInfor from "../ContactInformation";
import AddNote from "../AddNote";
import NoteHistory from "../NoteHistory";
import { CallerInforContext } from "../../contexts/customerProfile";
import config from "../../staticConfig";
import axios from "axios";
import { debounce } from "lodash";
import { TypeCallerInfor, TypeNoteHistoryItem } from "../../types/TypeContact";
import Row from "antd/lib/row";
import { StyledCol, StyledOptionWrapper } from "./styledComponents";
import { NoteHistoryContext } from "../../contexts/noteHistory";

const { Option } = Select;
const StyledSelect = styled(Select)`
  margin-top: 24px;
`;
const StyledUserAddIcon = styled(AddContactIcon)`
  margin-left: 13px;
`;

const ContactSearch: FC = () => {
  const { exsitingCaller, callerInfor, updateCallerInfor } = useContext(
    CallerInforContext
  );
  const { updateNoteHistoryList } = useContext(NoteHistoryContext);

  const [addNewCaller, setAddNewCaller] = useState<boolean>(false);
  const [selectedProfile, setSelectedProfile] = useState<string>();
  const [contactsList, setContactsList] = useState<TypeCallerInfor[]>([]);
  const [searching, setSearching] = useState<boolean>(false);

  const addNewContact = () => {
    if(exsitingCaller) {
      setContactsList([]);
      updateNoteHistoryList([], true);
      setSelectedProfile(undefined);
      updateCallerInfor(undefined)
    }
    setAddNewCaller(true);
  };

  const debounceSearch = debounce((val: string) => {
    setContactsList([]);
    if (val.trim().length > 0) {
      try {
        setSearching(true);
        const endpointUrl = `${
          config.apiGatewayEndpoint
        }/customersearch?searchContent=${val
          .toLowerCase()
          .trim()}&matchType=ALL`;
        axios.get(endpointUrl).then((r) => {
          setContactsList(r.data);
          setSearching(false);
        });
      } catch (err) {
        console.error(`Seasrch by content ${val} error`, err);
        setSearching(false);
      }
    }
  }, parseInt(config.customerSearchDebounce!));

  const handleSelect = (val: any, option: any) => {
    const selected = contactsList.find((c) => c.phoneNumber === val!);
    setSelectedProfile(selected!.customerName);
    updateCallerInfor(selected!);
    // loading notes
    try {
      const endpointUrl = `${
        config.apiGatewayEndpoint
      }/notesearch?phoneNumber=${val.replace("+", "")}`;
      axios.get(endpointUrl).then((response) => {
        const filteredNotes = response.data.filter(
          (n: TypeNoteHistoryItem) => n.contactNotes && n.contactNotes !== ""
        );
        updateNoteHistoryList(filteredNotes.reverse(), true);
      });
    } catch (error) {
      console.error("Retrieve note history error", error);
    }
  };

  return (
    <>
      <StyledSelect
        value={selectedProfile}
        showSearch
        placeholder="Search by name, company, or phone number"
        onSearch={debounceSearch}
        style={{ width: 375, height: 32 }}
        loading={searching}
        filterOption={false}
        defaultActiveFirstOption={false}
        onSelect={handleSelect}
        /*disabled={exsitingCaller}*/
      >
        {contactsList.map((c, index) => {
          return (
            <Option key={index} value={c.phoneNumber}>
              <StyledOptionWrapper>
                <Row>
                  <StyledCol span={24}>{c.customerName}</StyledCol>
                </Row>
                <Row>
                  <StyledCol span={12} className="content">
                    {c.company}
                  </StyledCol>
                  <StyledCol span={12} className="content alignRight">
                    {c.phoneNumber}
                  </StyledCol>
                </Row>
              </StyledOptionWrapper>
            </Option>
          );
        })}
      </StyledSelect>
      {!addNewCaller ? (
        <StyledUserAddIcon
          style={{ fontSize: "18px" }}
          onClick={addNewContact}
        />
      ) : null}
      {exsitingCaller || addNewCaller ? (
        <ContactInfor
          caller={callerInfor!}
          exsitingCaller={exsitingCaller}
        ></ContactInfor>
      ) : null}
      {exsitingCaller ? (
        <>
          <AddNote></AddNote>
          <NoteHistory></NoteHistory>
        </>
      ) : null}
    </>
  );
};

export default ContactSearch;
